var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.countryCode == "ca"
    ? _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            x: "0px",
            y: "0px",
            width: "56",
            height: "44",
            viewBox: "0 0 56 40",
            "enable-background": "new 0 0 56 40",
            "xml:space": "preserve",
          },
        },
        [
          _c("polygon", {
            attrs: { fill: "#A41C1C", points: "0,8 0,24 13.86,16 " },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#A41C1C",
              d: "M12.97,17.53v12.94L1.77,24L12.97,17.53 M13.86,16L0,24l13.86,8V16L13.86,16z",
            },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#D81D1D", points: "13.86,16 13.86,0 0,8 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#E59A2C", points: "27.71,8 27.71,24 13.86,16 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "none", points: "13.86,32 13.86,16 27.71,24 " },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#E59A2C",
              d: "M26.83,25.53v12.94L15.62,32L26.83,25.53 M27.71,24l-13.86,8l13.86,8V24L27.71,24z",
            },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#FFAD28", points: "13.86,16 13.86,0 27.71,8 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#30AA9B", points: "55.43,8 55.43,24 41.57,16 " },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#30AA9B",
              d: "M42.45,17.53L53.66,24l-11.21,6.47V17.53 M41.57,16v16l13.86-8L41.57,16L41.57,16z",
            },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#33C1B3", points: "41.57,16 41.57,0 55.43,8 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#11557F", points: "27.71,8 27.71,24 41.57,16 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "none", points: "41.57,32 41.57,16 27.71,24 " },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#11557F",
              d: "M28.6,25.53L39.8,32L28.6,38.47V25.53 M27.71,24v16l13.86-8L27.71,24L27.71,24z",
            },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#0D5F9A", points: "41.57,16 41.57,0 27.71,8 " },
          }),
        ]
      )
    : _c(
        "svg",
        {
          attrs: {
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            x: "0px",
            y: "0px",
            width: "56",
            height: "44",
            viewBox: "0 0 56 40",
            "enable-background": "new 0 0 56 40",
            "xml:space": "preserve",
          },
        },
        [
          _c("polygon", {
            attrs: { fill: "#A41C1C", points: "0,8 0,24 13.86,16 " },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#A41C1C",
              d: "M12.97,17.53v12.94L1.77,24L12.97,17.53 M13.86,16L0,24l13.86,8V16L13.86,16z",
            },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#D81D1D", points: "13.86,16 13.86,0 0,8 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#E59A2C", points: "27.71,8 27.71,24 13.86,16 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "none", points: "13.86,32 13.86,16 27.71,24 " },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#E59A2C",
              d: "M26.83,25.53v12.94L15.62,32L26.83,25.53 M27.71,24l-13.86,8l13.86,8V24L27.71,24z",
            },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#FFAD28", points: "13.86,16 13.86,0 27.71,8 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#30AA9B", points: "55.43,8 55.43,24 41.57,16 " },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#30AA9B",
              d: "M42.45,17.53L53.66,24l-11.21,6.47V17.53 M41.57,16v16l13.86-8L41.57,16L41.57,16z",
            },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#33C1B3", points: "41.57,16 41.57,0 55.43,8 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#11557F", points: "27.71,8 27.71,24 41.57,16 " },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "none", points: "41.57,32 41.57,16 27.71,24 " },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#11557F",
              d: "M28.6,25.53L39.8,32L28.6,38.47V25.53 M27.71,24v16l13.86-8L27.71,24L27.71,24z",
            },
          }),
          _vm._v(" "),
          _c("polygon", {
            attrs: { fill: "#0D5F9A", points: "41.57,16 41.57,0 27.71,8 " },
          }),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }